<div class="modal-form">
  <div class="form-modal">
    <div class="close-button" (click)="close()">
      x
    </div>
    <h4 style="color:#e7403f;margin-bottom: 30px">AGREGAR DATOS A MÓDULO MULTIMEDIA</h4>

    <div class="form-group row">
      <label for="nombre" class="col-sm-2 col-form-label">Nombre</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" style="color: #000" id="nombre" placeholder="Ejemplo: Captarmedia2" [(ngModel)]="newFrame_nombre">
      </div>
    </div>
    <div class="form-group row" *ngIf="newFrame_idTipo?.type === 'news-frame'">
      <label for="noticia-texto" class="col-sm-2 col-form-label">Noticia</label>
      <div class="col-sm-10">
        <textarea class="form-control" id="noticia-texto" rows="6"
                  placeholder="Ingrese el contenido de la noticia que se mostrará en el frame"
                  [(ngModel)]="newFrame_texto"></textarea>
      </div>
    </div>
    <div class="form-group row">
      <label for="tipo" class="col-sm-2 col-form-label">Tipo</label>
      <div class="col-sm-10" ngbDropdown>
        <button class="btn" id="dropdownBasic1" ngbDropdownToggle id="tipo" style="width: 100%; text-align: left;">
          {{newFrame_idTipo ? newFrame_idTipo.descripcion: 'SELECCIONAR TIPO'}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="width: 300px">
          <span *ngFor="let tipo of tipos">
            <button class="dropdown-item"   (click)="selectTipo(tipo)" *ngIf="!tipo.hide"
                    [disabled]="!tipo.active" [ngStyle]="{'cursor':tipo.active? 'pointer':'default'}"
            >{{tipo.descripcion}}
          </button>
          </span>
        </div>
      </div>
    </div>
    <!--
    <div class="form-group row">
      <label for="duracion" class="col-sm-2 col-form-label">Duracion</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" style="color: #000" id="duracion" placeholder="Duracion" [(ngModel)]="newFrame_duracion">
      </div>
    </div>
    -->
    <br>
    <div class="form-group" style="text-align: center">
      <button type="button" (click)="showSubirArchivo()"
              [disabled]="!newFrame_idTipo || (newFrame_idTipo.type === 'news-frame' ? !newFrame_texto : !newFrame_nombre)"
              [ngClass]="{'btn-danger':newFrame_idTipo && (newFrame_idTipo.type === 'news-frame' ? newFrame_texto : newFrame_nombre)}"
              style=" margin-top: 10px;  margin:10px"
              class="btn btn-lg">Siguiente
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/upload-form/upload-form.component.html